import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppLayout } from "@/layout/AppLayout";
import { tokens } from "@/shared/api/http";
import { useSession } from "./context/SessionContext";
import CriarSenhaView from "./views/CriarSenha";

/** Rotas do sistema interno: sem sessão, vai para o login e volta depois. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { usuario, carregando } = useSession();
  const location = useLocation();
  // Com login salvo no navegador, a tela abre na hora (com o skeleton dela) enquanto a sessão é
  // conferida; se a API recusar, cai no login logo abaixo. Sem login salvo, só o shell até redirecionar.
  if (carregando) return tokens.get() ? <>{children}</> : <AppLayout semConteudo />;
  if (!usuario) return <Navigate to="/" replace state={{ de: location.pathname + location.search }} />;
  // Senha que veio de outra pessoa (cadastro, "Reenviar acesso"): nada do sistema abre antes da senha nova.
  if (usuario.senhaTemporaria) return <CriarSenhaView />;
  return <>{children}</>;
}
